import "./App.css";
import Router from "./router/router";
import { Provider } from "react-redux";
import { store } from "./store";
import ToastNotification from "./components/ToastNotification";
import { useEffect } from "react";
import IndividualSubscriptionService from "./services/subscription/individualSubscription";

function App() {
  const isLoggedin = localStorage.getItem("guideproaAI_admin");
  

  return (
    <body class="dark">
      <Provider store={store}>
        <ToastNotification />
        <Router isLoggedin={isLoggedin} />
      </Provider>
    </body>
  );
}

export default App;
